<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 class="h2">Einstellungen</h1>
</div>

<form autocomplete="off" *ngIf="user">
    <div class="row">
        <div class="col">
            <label>Name</label>
            <p>{{ user.name }}</p>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <label>E-Mail</label>
            <p>
                <a [href]="'mailto:' + user.email">{{ user.email }}</a>
            </p>
        </div>
    </div>
</form>
